import Modal from "../../../global/components/Modal/Modal.vue";
import PuxButton from "../../../global/components/PuxButton/PuxButton.vue";
import PuxTranslate from "../../../global/components/PuxTranslate/PuxTranslate.vue";

import HttpMixin from "../../../global/mixins/HttpMixin";
import NotificationMixin from "../../../global/mixins/NotificationMixin";

import {
  cloneDeep,
} from "lodash-es";

const DOKART = "7f8dbeeb-6f67-483d-acf8-9d325a8643d3";

// @vue/component
export default {
  name: "FoerderdokumenteModalCreate",
  components: {
    Modal,
    PuxButton,
    PuxTranslate,
  },
  mixins: [
    HttpMixin,
    NotificationMixin,
  ],
  props: {
    close: {
      type: Function,
      default: () => {},
    },
    selectorClose: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      model: {},
      options: {
        showCloseButton: true,
        required: true,
        style: "height: 360px;",
        list: [
          {
            id: "fod_name",
            type: "text",
            label: "_LBL_FOERDERDOKUMENTE_LIST_FOERDERDOKUMENT_MODAL_CREATE_NAME_",
            required: true,
            maxlength: 200,
            view: "v",
          },
          {
            id: "dokart",
            type: "select",
            label: "_LBL_FOERDERDOKUMENTE_LIST_FOERDERDOKUMENT_MODAL_CREATE_DOKUMENTTYP_",
            required: true,
            view: "v",
            keyId: "pk",
            keyLabel: "name",
            menuWidthAll: true,
            url: `dokumentarten/?klasse=${ DOKART }`
          },
        ],
      },
      status: {
        loading: undefined,
      },
      errors: undefined,
      errorsClone: undefined,
    };
  },
  methods: {
    save() {
      this.status.loading = true;
      const data = cloneDeep(this.model);
      this.postHttp({ url: `foerderdokumente/`, data }).then(
        response => {
          this.addNotification({ text: "_MSG_FOERDERDOK_MODAL_CREATE_SUCCESS_" });
          this.close();
          this.$goTo("root.foerderdokumente.details", { id: response.pk });
        },
        error => {
          this.errors = error.data;
          this.errorsClone = error.data;
        }
      ).then(
        () => this.status.loading = false
      );
    },
  },
};
